import * as React from "react";
import {session} from "../../clientInstance";
import {Permission} from "../../client/resources";

export interface PermissionCheckProps {
    permission: Permission | Permission[];
    children?: any;
    alternate?: any;
    project?: string;
    tenant?: string;
    environment?: string;
    projectGroup?: string;
    wildcard?: boolean;
}

const PermissionCheck = (props: PermissionCheckProps) => {
    const allowed = isAllowed(props);
    const alternate = props.alternate || null;
    const children = props.children || null;

    const renderChildren = () =>
        children && typeof children === "function"
            ? children() : children;

    return <div>{allowed ? renderChildren() : alternate}</div>;
};

export function isAllowed(props: PermissionCheckProps) {
    const pid: string = props.project || (props.wildcard ? "*" : null);
    const eid: string = props.environment || (props.wildcard ? "*" : null);
    const gid: string = props.projectGroup || (props.wildcard ? "*" : null);
    const tid: string = props.tenant || (props.wildcard ? "*" : null);

    const permissions = (props.permission instanceof Array)
        ? props.permission
        : [props.permission];

    const checks: boolean[] = permissions.map(p => {
        return session.currentPermissions.isAuthorized({
            permission: p,
            projectId: pid,
            environmentId: eid,
            projectGroupId: gid,
            tenantId: tid
        });
    });

    return checks.some(x => x);
}

export function firstAuthorized(permissions: Permission[]): Permission {
    return session.currentPermissions.firstAuthorized(permissions);
}

export default PermissionCheck;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/PermissionCheck/PermissionCheck.tsx